module.exports = __webpack_public_path__ + "img/05.08f9c278.jpg";